export const TRANSFER_TABS = [
  {
    text: 'All',
    value: 'all',
    subValue: '',
  },
  {
    text: 'Awaiting Confirmation',
    value: 'AWAITING_CONFIRMATION',
    subValue: ['AWAITING_CONFIRMATION'],
  },
  {
    text: 'Confirmed Pick',
    value: 'CONFIRMED_PICK',
    subValue: ['CONFIRMED_PICK'],
  },
  {
    text: 'Shipping',
    value: 'SHIPPING',
    subValue: ['SHIPPING'],
  },
  // {
  //   text: 'Received',
  //   value: 'RECEIVED',
  //   components: <Received />,
  // },
  {
    text: 'Rejected',
    value: 'REJECTED',
    subValue: ['REJECTED'],
  },
  {
    text: 'Completed',
    value: 'COMPLETED',
    subValue: ['COMPLETED'],
  },
  {
    text: 'Cancelled',
    value: 'CANCELLED',
    subValue: ['CANCELLED'],
  },
];
